import { t } from 'i18next';

import type { GridSingleSelectColDef } from '@packages/fenrir/components/datagrid';
import {
  getFilteredGridSelectOperators,
  GridSelectOperator,
} from '@packages/fenrir/components/datagrid';

import { BooleanCell } from '../cell/boolean-cell/boolean-cell';

const booleanOptions = [
  { label: t('ui:yes'), value: 'true' },
  { label: t('ui:no'), value: 'false' },
];

export const booleanColumnType: Omit<GridSingleSelectColDef, 'field'> = {
  display: 'flex',
  flex: 0.1,
  minWidth: 90,
  type: 'singleSelect',
  filterOperators: getFilteredGridSelectOperators([GridSelectOperator.Is]),
  valueOptions: booleanOptions,
  renderCell: (params) => <BooleanCell {...params} />,
};
